document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.show-result', {
    slidesPerView: 1,
    spaceBetween: 32,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
          const pageNumber = (index + 1).toString().padStart(2, '0');
          return `<p class="${className}">${pageNumber}</p>`;
      },
    },
    breakpoints: {
      991: {
          slidesPerView: 3,
          spaceBetween: 32,
      },
      750: {
          slidesPerView: 2,
          spaceBetween: 30,
      }
    },
  });
});
